module.exports = __webpack_public_path__ + "img/left-to-line.86b4a26a.svg";